<template>


  <div class="main">

    <!--undersida med vit bakgrund-->
    <transition appear name="turnIn">
      <!--<div class="page page-about">-->
      <simplebar class="page page-about" data-simplebar-auto-hide="true" v-bind:class="{ 'linkIsClicked' : linkClicked }">
        <h1><span class="page-about-welcome">Välkommen till vårt bröllop</span><span class="page-about-h1-date">24 juni 2022</span><span class="page-about-h1-place"><router-link to="/florens">Florens, Italien</router-link></span></h1>

        <!--<img src="../assets/namn2-opt.svg" alt="David Södertström &amp; Frida Nyvall" width="100%" height="100%" class="page-about-names"/>-->

        <figure class="page-about-names">
          <img src="../assets/namn-david.svg" alt="David Söderström" width="auto" height="100%" class="page-about-david"/>
          <img src="../assets/namn-och.svg" alt="&amp;" width="auto" height="100%" class="page-about-och"/>
          <img src="../assets/namn-frida.svg" alt="Frida Nyvall" width="auto" height="100%" class="page-about-frida"/>
        </figure>



        <figure class="page-about-img-korea">
          <img src="../assets/korea3.jpg" width="100%" height="auto" alt="David och Frida"/>
        </figure>

<!--
        <figure class="page-about-img">
          <img src="../assets/davidofrida.jpg" width="100%" height="auto" alt="David och Frida"/>
        </figure> -->


        <div class="page-about-schema">
          <h2><router-link to="/ceremoni">Ceremoni</router-link></h2>
          <p>Santa Maria Novella Hotel<br><span class="page-about-schema-time">16.00</span></p>

          <h2><router-link to="/middag">Middag</router-link></h2>
          <p>Ristorante Pensavo Peggio<br><span class="page-about-schema-time">20.00</span></p>
        </div><!--page-about-schema-->

        <hr class="page-hr" style="margin-top:0;">

        <navigation @link-clicked="linkClickedFunc" v-bind:linkClickedC="linkClicked"></navigation>

      <!--</div>page-->

      </simplebar>
    </transition>

  </div><!--main-->

</template>

<script>
import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css'; //importerar denna som vanlig scss istället med copy paste för att få den inbakad i vanliga css filen

import Navigation from '../components/Nav.vue';

export default {
  name: 'schema',
  components: {
    simplebar,
    Navigation
  },

  data: function () {
    return {
      linkClicked: false
    };
  },

  methods: {
    linkClickedFunc (emittedvalue) {
      this.linkClicked = emittedvalue;
      // console.log('linkClickedFunc kördes');
      return this.linkClicked;
    }
  },

  mounted: function () {
    // justering av höjden för scrollbar plugin
    const pageSubpage = document.getElementsByClassName('page-about')[0];
    const pageSubpageHeight = document.getElementsByClassName('page-about')[0].offsetHeight + 15;
    // console.log(pageSubpageHeight);
    pageSubpage.style.height = pageSubpageHeight + 'px';
  }
};
</script>